import { Box, FlexBox, Icon } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { useMatch } from 'react-router-dom';

import { AppLink } from 'components/appLink';
import { useBreakpointValue } from 'utils/mediaQuery';

import { ContactsSidebar } from './components/sidebar/contactsSidebar';
import styles from './contacts.module.scss';

type ContactsProps = {
  list: ReactElement;
  details?: ReactElement;
};

export const ContactsView = ({ list, details }: ContactsProps): JSX.Element => {
  const companyMatch = useMatch('/contacts/company/:id');
  const userMatch = useMatch('/contacts/user/:id');

  const hasItemSelected = !!userMatch || !!companyMatch;

  const shouldShowBackButton = useBreakpointValue([
    hasItemSelected,
    null,
    false,
  ]);

  const rootClass = classNames(
    {
      [styles.rootHasItemSelected]: hasItemSelected,
    },
    styles.root,
  );

  return (
    <FlexBox height="100%" background="#fff" className={rootClass}>
      <Box className={styles.listPane}>
        <ContactsSidebar>{list}</ContactsSidebar>
      </Box>

      <Box className={styles.viewPane}>
        {shouldShowBackButton && (
          <Box padding="0 400" className={styles.viewPaneTop}>
            <AppLink
              path={`/contacts/${companyMatch ? 'company' : 'user'}`}
              className={styles.backLink}
            >
              <Icon name="angle-left" size={24} />{' '}
              <Box>Back to {companyMatch ? 'companies' : 'contacts'}</Box>
            </AppLink>
          </Box>
        )}

        <FlexBox flex="1" className={styles.viewPaneBody} alignItems="center">
          {details}
        </FlexBox>
      </Box>
    </FlexBox>
  );
};
